<template>
  <div class="setup_step card">
    <h4>
      You’re ready to sell
    </h4>
    <p>
      Below are the links to the checkout pages where customers can now sign up for your products. These links will
      also be accessible from within the dashboard. Customers can start using the product immediately after signing up.
    </p>
    <div class="links card">
      <ul>
        <li
          v-for="(link, index) in links"
          :key="index"
        >
          <span v-html="link.name" />
          <a
            href="javascript:;"
            :title="link.name"
            class="button"
            @click="clipboard(link.url)"
          >
            {{ link.url }} <svg-vue icon="icons/copy" />
          </a>
        </li>
      </ul>
    </div>
    <button
      class="button"
      @click="setCurrentStep('COMPLETED')"
    >
      Go to Dashboard
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import {mapActions} from "vuex";

export default {
  data() {
    return {
      links: [],
    };
  },
  mounted() {
    this.fetchRegistrationLinks();
  },
  methods: {
    ...mapActions('merchantCentreSetupWizard', [
      'setCurrentStep',
    ]),
    fetchRegistrationLinks() {
      axios.get('/merchant/registration-links')
        .then(({ data }) => {
          this.links = data.links;
        });
    },
    clipboard(link) {
      if (!window.isSecureContext) {
        Swal.fire({
          icon: 'error',
          title: 'Insecure connection',
          html: 'Unable to write to clipboard, please copy and paste:<br>'+link,
        });
        return;
      }
      navigator.clipboard.writeText(link);
      Swal.fire('Copied to clipboard!');
    },
  },
}
</script>

<style lang="scss" scoped>
.merchant_centre_wizard {
  .setup_form {
    .setup_step {
      > h4 {
        margin: 0 0 0.5rem 0;
      }

      .links {
        background: #FBFAFA;
        padding: 1rem;

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            padding-bottom: 1rem;

            span {
              font-size: 1.125rem;
              font-weight: 500;
              color: #040707;
              padding-bottom: 0.5rem;
              display: inline-block;
              line-height: 1rem;
            }

            a {
              display: block;
              border: 1px solid #37B2A8;
              background: white;
              color: #37B2A8;
              font-size: 0.875rem;
              text-align: center;
              line-height: 1.5rem;
            }

            svg {
              width: 1rem;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
</style>
